'use strict';

angular.module('TurneroApp').component('coUsuarios', {
    bindings: {
        centroAtencionSeleccionado: '<',
        ctrlAdmin: '='
    },
    controller: [
        'usuariosService',
        'utilsService',
        'TurneroAppConstant',
        function (usuariosService, utilsService, TurneroAppConstant) {
            var ctrl = this;

            ctrl.isOpenDialog = false;
            ctrl.usuarioCrear = false;
            ctrl.usuarioModificar = false;
            ctrl.usuarioConsultar = true;
            ctrl.usuarioVer = false;
            ctrl.usuarios = [];
            ctrl.focusBuscar = false;
            ctrl.permisos = TurneroAppConstant.Permisos;
            ctrl.tLoadAlta = null;
            ctrl.tLoadModificar = null;

            //Consultar permisos del usuario
            //var seguridadService;
            //seguridadService = $injector.get('seguridadService');
            ctrl.limitOptions = [10, 25, 50, 75, 100, {
                label: 'Todos',
                value: function () {
                    return ctrl.pagination.total;
                }
            }];

            ctrl.query = {
                limit: 10,
                page: 1,
                filter: ''
            };

            //Se inicializa en null para que al principio no tome que no hay valores
            ctrl.pagination = {
                total: null
            };

            ctrl.filter = false;

            ctrl.$onChanges = function () {
                ctrl.centroAtencionSeleccionado.id && ctrl.grillaReload();
            };

            ctrl.removeFilter = function () {
                ctrl.query.filter = '';
                ctrl.grillaReload();
                ctrl.filter = false;
            };

            ctrl.mostrarBuscar = function () {
                ctrl.filter = true;
                ctrl.focusBuscar = true;
            };

            ctrl.grillaReload = function () {
                ctrl.usuarioConsultar = true;
                ctrl.usuarioCrear = false;
                ctrl.usuarioModificar = false;
                ctrl.usuarioVer = false;

                if (!ctrl.query.filter || ctrl.query.filter.length > 2) {
                    ctrl.getData(ctrl.query.page, ctrl.query.limit, 'grid', cargarDatos)
                }
            };

            ctrl.getData = function (page, limit, tipo, callback) {

                ctrl.promise = usuariosService.getfiltro({
                    'filtro.id_Centro_Atencion': ctrl.centroAtencionSeleccionado.id,
                    'filtro.nro_Pagina': page,
                    'filtro.tam_Pagina': limit,
                    'filtro.texto': ctrl.query.filter
                }).$promise.then(function (res) {
                    if (res.Data.length > 0) {

                        for (var i = 0; i < res.Data.length; i++) {
                            var arrayRoles = res.Data[i].N_Roles.split(',');
                            res.Data[i].N_Roles_List = [];
                            for (var j = 0; j < arrayRoles.length; j++) {
                                var arrayRolDesc = arrayRoles[j].split('|');
                                res.Data[i].N_Roles_List.push({
                                    'tipo': arrayRolDesc[0],
                                    'descripcion': arrayRolDesc[1]
                                });
                            }
                        }
                    }
                    callback(tipo, res);
                }).catch(function (req) {
                    utilsService.errores(req);
                });
            }

            function cargarDatos(tipo, data) {
                if (tipo == 'grid') {
                    ctrl.usuarios = data.Data;
                    ctrl.pagination.total = data.Paging.Reg_Totales;
                } else if (tipo == 'xls') {
                    var arrayObjeto = data.Data;
                    ctrl.arrayExport = [];
                    ctrl.arrayExport[0] = [ctrl.centroAtencionSeleccionado.id, ctrl.centroAtencionSeleccionado.text];
                    ctrl.arrayExport[1] = ['CUIL', 'Nombre', 'Roles'];
                    for (var i = 0; i < arrayObjeto.length; i++) {
                        var roles = '';
                        for (var rol = 0; rol < arrayObjeto[i].N_Roles_List.length; rol++) {
                            roles = roles ? roles + (arrayObjeto[i].N_Roles_List[rol].tipo ? ', ' + arrayObjeto[i].N_Roles_List[rol].tipo : '') : (arrayObjeto[i].N_Roles_List[rol].tipo ? arrayObjeto[i].N_Roles_List[rol].tipo : '');
                        }
                        ctrl.arrayExport[i + 2] = [
                            arrayObjeto[i].CUIL.substring(0, 2) + '-' + arrayObjeto[i].CUIL.substring(2, 10) + '-' + arrayObjeto[i].CUIL.substring(10, 12),
                            arrayObjeto[i].Agente,
                            roles
                        ]
                    }
                    swal.close();
                    ctrl.Excel.down([{
                        name: 'Roles',
                        data: ctrl.arrayExport
                    }]);
                }
            }

            //ALTA USUARIO
            ctrl.LoadAlta = function () {
                ctrl.limpiarMemoria();
                ctrl.usuarioCrear = true;
                ctrl.tLoadAlta();
            };
            
            ctrl.modificarUsuario = function (item) {
                ctrl.limpiarMemoria();
                ctrl.usuarioModificar = true;
                ctrl.tLoadModificar(item);
            };

            ctrl.verUsuario = function (item) {
                ctrl.limpiarMemoria();
                ctrl.usuarioVer = true;
                ctrl.tLoadModificar(item);
            };

            ctrl.eliminarUsuario = function (item) {
                swal({
                    title: "Eliminar Usuario",
                    text: "¿Desea quitar el usuario del centro de atención?",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#e77a1e",
                    confirmButtonText: "Si, eliminarlo!",
                    cancelButtonText: "No, cancelar!"
                }).then(function () {
                    usuariosService.delete({ 'id': item.Id_centro_usuario }).$promise.then(function (res) {
                        ctrl.grillaReload();
                        swal("Eliminado!", "El usuario ha sido eliminado del centro correctamente.", "success");
                    }).catch(function (req) {
                        utilsService.errores(req);
                    });
                });
            };

            ctrl.validarSiTieneSU = function (roles) {

                if (roles.length) {
                    if (roles.length > 1) {
                        for (var i = 0; i < roles.length; i++) {
                            if (roles[i].Id_Rol == TurneroAppConstant.Roles.SU) {
                                return false;
                            };
                        }
                    }

                    return true;
                }
            }

            ctrl.roles = function (usuario) {
                var listado_roles = '';
                if (usuario.N_Roles_List.length) {
                    //se genera el html para el listado de roles
                    for (var i = 0; i < usuario.N_Roles_List.length; i++) {
                        listado_roles = listado_roles + '<label title="' + usuario.N_Roles_List[i].descripcion + '" style="' + (usuario.N_Roles_List[i].tipo == 'SU' ? "background: #971B2F" : "background: #004B81") + '" class="label label-rol">' + usuario.N_Roles_List[i].tipo + '</label>';
                        if (((i + 1) / 5).isInteger()) {
                            listado_roles = listado_roles + '<br style="line-height: 30px;"	/>'
                        }
                    }
                }
                return listado_roles

            }

            ctrl.limpiarMemoria = function () {
                ctrl.usuarios = [];
                ctrl.usuarioCrear = false;
                ctrl.usuarioModificar = false;
                ctrl.usuarioConsultar = false;
                ctrl.usuarioVer = false;
            }

            //EXPORTAR A EXCEL
            ctrl.isOpen = false;
            ctrl.selectedMode = 'md-fling';
            ctrl.selectedDirection = 'up';
            ctrl.exportar = function (tipo) {
                utilsService.swalTitle('Exportando datos', 'info')
                ctrl.arrayExport = [];
                ctrl.getData(1, ctrl.pagination.total, tipo, cargarDatos)

            }
            ctrl.Excel = {
                down: function () {
                },
            }
        }
    ],
    template: require('./usuarios.html')
});


// WEBPACK FOOTER //
// ./app/components/usuarios/usuariosComponent.js